import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutProgressMobileBottomComponent } from '@spartacus/checkout/base/components';
import { ICON_TYPE } from '../../../../../../../custom/icons/icon.model';

@Component({
  selector: 'cx-checkout-progress-mobile-bottom',
  templateUrl: './checkout-progress-mobile-bottom.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class CustomCheckoutProgressMobileBottomComponent extends CheckoutProgressMobileBottomComponent {
  iconType = ICON_TYPE;
}
